import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';

type Props = {
  open: boolean;
  email: string;
  displayName: string;
  loading?: boolean;
  error?: string | null;
  onClose: () => void;
  onConfirm: (confirmEmail: string) => void;
};

const ConfirmDeleteUserDialog: React.FC<Props> = ({
  open,
  email,
  displayName,
  loading,
  error,
  onClose,
  onConfirm,
}) => {
  const [typed, setTyped] = useState('');
  const matches = typed.trim().toLowerCase() === email.trim().toLowerCase();

  useEffect(() => {
    if (open) {
      setTyped('');
    }
  }, [open, email]);

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Delete user and attached data</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 1.5 }}>
          This permanently deletes <strong>{displayName}</strong> ({email}) and
          their profile, subscriptions, payments, progression, messages, posts,
          sessions, and tracking. Curriculum they authored stays in the library.
          This cannot be undone.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Type the email address to confirm.
        </Typography>
        <TextField
          autoFocus
          fullWidth
          size="small"
          label="Email"
          value={typed}
          onChange={(e) => setTyped(e.target.value)}
          disabled={loading}
        />
        {error ? (
          <Typography variant="body2" color="error" sx={{ mt: 1 }}>
            {error}
          </Typography>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          color="error"
          variant="contained"
          disabled={!matches || loading}
          onClick={() => onConfirm(typed.trim())}
        >
          {loading ? 'Deleting…' : 'Delete permanently'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteUserDialog;
